"use client"

import { Fragment, useEffect } from "react"
// import { useMediaQuery } from "react-responsive"
import "simplebar/dist/simplebar.min.css"
// import useMounted from "../../hooks/useMounted"
// import QuickMenuDesktop from "./notification/QuickMenuDesktop"
// import QuickMenuMobile from "./notification/QuickMenuMobile"
import socket from "../socket/socket"
import { useDispatch, useSelector } from "react-redux"
import {
  getNotificationListAction,
  getOperatorOrManagerListAction,
  updateNotificationAction,
} from "../../services/action/common"
import { getUserAction } from "../../services/action/authentication"
import { useNavigate } from "react-router-dom"
import { useRef, useCallback, useMemo } from "react"

const MANAGER_ROLES = ["MANAGER", "ADMIN", "SUPER_ADMIN"]

// Create AudioContext instance
let audioContext = null

const QuickMenu = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.authenticationReducer)
  const notificationBufferRef = useRef(null)
  const newLeadBufferRef = useRef(null)
  // const hasMounted = useMounted()
  // const [isNotificationOpen, setIsNotificationOpen] = useState(false)

  // const isDesktop = useMediaQuery({
  //   query: "(min-width: 768px)",
  // })

  const userType = useMemo(() => user?.userType?.toLowerCase(), [user?.userType])

  // Initialize audio context and load sounds
  const initializeAudio = useCallback(async () => {
    try {
      if (!audioContext) {
        audioContext = new (window.AudioContext || window.webkitAudioContext)()
      }

      // Load notification sound
      if (!notificationBufferRef.current) {
        const notificationResponse = await fetch("/assets/ringtone.wav")
        const notificationArrayBuffer = await notificationResponse.arrayBuffer()
        notificationBufferRef.current = await audioContext.decodeAudioData(notificationArrayBuffer)
      }

      // Load new lead sound
      if (!newLeadBufferRef.current) {
        const newLeadResponse = await fetch("/assets/ads-leads.wav")
        const newLeadArrayBuffer = await newLeadResponse.arrayBuffer()
        newLeadBufferRef.current = await audioContext.decodeAudioData(newLeadArrayBuffer)
      }
    } catch (error) {
      console.error("Error initializing audio:", error)
    }
  }, [])

  // Play sound using AudioContext
  const playSound = useCallback(
    async (buffer) => {
      try {
        if (!audioContext) {
          await initializeAudio()
        }

        if (audioContext.state === "suspended") {
          await audioContext.resume()
        }

        const source = audioContext.createBufferSource()
        source.buffer = buffer
        source.connect(audioContext.destination)
        source.start(0)
      } catch (error) {
        console.error("Error playing sound:", error)
      }
    },
    [initializeAudio],
  )

  // Handle notification socket event
  const handleNotification = useCallback(
    ({
      orderId,
      notificationId: _id,
      subject,
      messageId,
      senderId,
      sendTime,
      leadId,
      senderName,
      message,
      messageType,
      userId,
      visitorId,
      messageNewMessageCount,
    }) => {
      if (messageType === "EXTERNAL") {
        dispatch(getNotificationListAction({ userType }))
      } else {
        dispatch(
          updateNotificationAction({
            orderId,
            _id,
            subject,
            visitorId,
            messageId,
            senderId,
            sendTime,
            leadId,
            senderName,
            message,
            messageType,
            userId,
            messageNewMessageCount,
          }),
        )
      }

      if (notificationBufferRef.current) {
        playSound(notificationBufferRef.current)
      }
    },
    [dispatch, userType, playSound],
  )

  // Handle new lead socket event
  const navigate = useNavigate()
  const handleNewLead = useCallback(() => {
    dispatch(
      getUserAction({
        hideError: true,
        errorCb: () => {
          localStorage.clear()
          navigate("/")
        },
      }),
    )
    if (newLeadBufferRef.current) {
      playSound(newLeadBufferRef.current)
    }
  }, [dispatch, playSound, navigate])

  // Initialize audio on component mount
  useEffect(() => {
    initializeAudio()

    // Add click event listener to initialize audio context
    const handleUserInteraction = () => {
      if (audioContext && audioContext.state === "suspended") {
        audioContext.resume()
      }
    }

    document.addEventListener("click", handleUserInteraction)
    return () => {
      document.removeEventListener("click", handleUserInteraction)
    }
  }, [initializeAudio])

  // Fetch notifications for non-marketing users
  useEffect(() => {
    if (user?.userType !== "MARKETING" && user?.userType !== "ACCOUNTS" && user?.userType !== "HR") {
      dispatch(getNotificationListAction({ userType }))
    }
  }, [dispatch, user?.userType, userType])

  // Fetch operator/manager list for authorized roles
  useEffect(() => {
    if (MANAGER_ROLES.includes(user?.userType)) {
      dispatch(getOperatorOrManagerListAction({ userType }))
    }
  }, [dispatch, user?.userType, userType])

  // Socket event listeners
  useEffect(() => {
    socket.on("send_notification", handleNotification)
    socket.on("new_lead_ads", handleNewLead)

    return () => {
      socket.off("send_notification", handleNotification)
      socket.off("new_lead_ads", handleNewLead)
    }
  }, [handleNotification, handleNewLead])

  useEffect(() => {
    socket.connect()

    socket.on("send_new_notification", (data) => {
      if (data?.visibleTo?.includes(user?.userType) && user?._id != data?.senderId) {
        dispatch(getNotificationListAction({ userType: user?.userType }))
      }
      if (data?.visibleTo?.includes(user?.userType) && user?._id != data?.senderId && notificationBufferRef.current) {
        playSound(notificationBufferRef.current)
      }
    })

    return () => {
      socket.off("send_new_notification")
      socket.disconnect()
    }
  }, [user, dispatch, userType, playSound])

  // const toggleNotification = (value) => {
  //   if (typeof value === "boolean") {
  //     setIsNotificationOpen(value)
  //   } else {
  //     setIsNotificationOpen(!isNotificationOpen)
  //   }
  // }

  return (
    <Fragment>
      {/* {hasMounted &&
        (isDesktop ? (
          <QuickMenuDesktop isOpen={isNotificationOpen} toggleNotification={toggleNotification} />
        ) : (
          <QuickMenuMobile isOpen={isNotificationOpen} toggleNotification={toggleNotification} />
        ))} */}
    </Fragment>
  )
}

export default QuickMenu

